/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Slug_TakenInputs */

const en_adm_err_slug_taken = /** @type {(inputs: Adm_Err_Slug_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A role with this name already exists.`)
};

const de_adm_err_slug_taken = /** @type {(inputs: Adm_Err_Slug_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Rolle mit diesem Namen gibt es bereits.`)
};

/**
* | output |
* | --- |
* | "A role with this name already exists." |
*
* @param {Adm_Err_Slug_TakenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_slug_taken = /** @type {((inputs?: Adm_Err_Slug_TakenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Slug_TakenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_slug_taken(inputs)
	return en_adm_err_slug_taken(inputs)
});